import { Component, OnInit, signal, computed, ChangeDetectionStrategy } from '@angular/core';

import { ApplicationInformationService } from '../../../services/application-information-service/application-information.service';
import { UserConfigurationService } from '../../../services/userconfiguration/user-configuration.service';

@Component({
  selector: 'release-version-link',
  templateUrl: './release-version-link.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class ReleaseVersionLinkComponent implements OnInit {
  protected readonly releaseDocURL = signal('');
  protected readonly releaseNumber = signal(this.appInfoService.version);
  protected readonly isAvailable = computed(() => !!this.releaseDocURL());

  constructor(
    private readonly appInfoService: ApplicationInformationService,
    private readonly configService: UserConfigurationService
  ) {}

  ngOnInit(): void {
    this.releaseNumber.set(this.configService.getOrDefault('RELEASE_NUMBER'));
    this.releaseDocURL.set(this.configService.getOrDefault('RELEASE_DOCUMENTATION_URL'));
  }

  openReleaseDocumentation(): void {
    const url = this.releaseDocURL();
    if (url) {
      window.open(url, '_blank');
    }
  }
}
